export default __webpack_public_path__ + "static/media/ph_eye_opened_black_fill@2x.551b9b48.png";